export const PAGINATION_TAG_NAME = "pagination" as const;

export const ELLIPSIS_SLOT = "pagination-ellipsis";

export const DEFAULT_SIBLING_COUNT = 1;

export const DEFAULT_BOUNDARY_COUNT = 1;

export const PAGINATION_VARIANTS = [
  "default",
  "group",
  "minimal",
  "dots",
] as const;

export const PAGINATION_ALIGNS = ["start", "center", "end"] as const;

export const NAVIGATION_ICONS = {
  previous: "ChevronLeft",
  next: "ChevronRight",
} as const;

export const PREFETCH_REACTIVATE_MS = 5000;
